<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useTheme } from '@/composables/useTheme'

// Binärer Toggle (Hell ↔ Dunkel). Icon + Label richten sich nach dem aktuell
// sichtbaren Theme (effective), nicht nach pref — denn 'system' bleibt der
// unsichtbare Default (= Gerät), ist aber nicht mehr wählbar.
const { effective, cycle } = useTheme()
const { t } = useI18n()

const label = computed(() =>
  effective.value === 'dark' ? t('konto.modus_dunkel') : t('konto.modus_hell'),
)
</script>

<template>
  <button
    type="button"
    class="inline-grid place-items-center w-9 h-9 rounded-md
           text-fg-mid hover:text-fg hover:bg-hover
           focus-visible:bg-hover
           transition-colors"
    :aria-label="label"
    :title="label"
    @click="cycle()"
  >
    <!-- Light (Sonne) -->
    <svg
      v-if="effective === 'light'"
      width="18" height="18" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41
               M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
    <!-- Dark (Mond) -->
    <svg
      v-else
      width="18" height="18" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  </button>
</template>
